import * as React from 'react';

import { observer } from 'mobx-react';

import { CheckBox } from '@estee/elc-checkbox';
import { ICheckBox } from '@estee/elc-checkbox/typings/elc-checkbox/src/views/CheckBox';
import { FormStore } from '@estee/elc-form';
import { IFormValues } from '@estee/elc-form/typings/views/Form';
import { FieldError } from '@estee/elc-inputs';

import classnames from 'classnames';

import { PrimitiveValueType } from '~domain/entities/Config';
import { ckClasses, classes } from '~utils/Classes';
import { FieldValidations } from '~utils/FieldValidations';

export interface ICheckboxProps extends Omit<ICheckBox, 'label' | 'value'> {
    name: string;
    inputLabel: string;
    autoCheckFieldName?: string;
    fieldValidations?: FieldValidations;
    formStore: FormStore<IFormValues>;
}

@observer
export class Checkbox extends React.Component<ICheckboxProps> {
    public componentDidMount() {
        const { name, fieldValidations, formStore } = this.props;
        fieldValidations?.validations &&
            formStore.setFieldValidations(name, fieldValidations?.validations);
    }

    public componentWillUnmount() {
        const { formStore, name } = this.props;
        formStore.removeValidationField(name);
    }

    private onCheckboxChange = (isChecked: boolean = false, fieldName?: string) => {
        const { formStore, onChange, fieldValidations, autoCheckFieldName } = this.props;
        if (fieldName) {
            let checkedValue: PrimitiveValueType = isChecked;
            if (fieldValidations?.valueType === 'number') {
                checkedValue = isChecked ? 1 : 0;
            }
            formStore.setFieldValue(fieldName, checkedValue);
            autoCheckFieldName && formStore.setFieldValue(autoCheckFieldName, checkedValue);
            formStore.blurField(fieldName);
        }
        if (onChange) {
            onChange(isChecked, fieldName);
        }
    };

    public render() {
        const { name, inputLabel, formStore, ...restProps } = this.props;
        const isChecked = !!formStore.values[name];
        const error = formStore.getError(name);

        return (
            <div
                className={classnames(
                    classes('checkbox-field'),
                    isChecked && classes('checkbox-field-selected')
                )}
            >
                <CheckBox
                    {...restProps}
                    label={inputLabel}
                    value={name}
                    isChecked={isChecked}
                    onChange={this.onCheckboxChange}
                    className={ckClasses(name)}
                    dataTestId={`form_${name}`}
                />
                {error && <FieldError errorMessage={error} />}
            </div>
        );
    }
}
